export default class MyBetCombinationModel {
  constructor(data) {
    /**
     * @type {string}
     */
    this.betType = data.c;
    /**
     * @type {number}
     */
    this.bonus = data.b;
    /**
     * @type {string}
     */
    this.combStatus = data.cs;
    /**
     * @type {number}
     */
    this.numOfBets = data.n;
    /**
     * @type {number}
     */
    this.odds = data.o;
    /**
     * @type {number}
     */
    this.potWinnings = data.pw;
    /**
     * @type {number}
     */
    this.unitStake = data.us;
    /**
     * @type {number}
     */
    this.stake = data.n * data.us;
    /**
     * @type {number}
     */
    this.winnings = data.w;
    /**
     * @type {number}
     */
    this.tax = data.t;
    /**
     * @type {number}
     */
    this.combinationStatusId = data.csid;
  }
}
